<div class="menu" [ngClass]="menuStyle">
    <div class="menu-content-wrapper">
        <div class="menu-content">
            <ul class="menu-items">
                <ng-container *ngFor="let menuItem of menuItems"
                              [ngTemplateOutlet]="listMenu"
                              [ngTemplateOutletContext]="{item: menuItem}"></ng-container>
            </ul>
        </div>
    </div>
</div>

<ng-template #listMenu let-menuItem="item">
    <li class="menu-item"
        [class.has-sub-menu]="hasChildMenu(menuItem)"
        [class.opened]="menuItem?.isOpened"
        (click)="toggleMenu($event, menuItem)">
        <a mat-button
           *ngIf="!hasChildMenu(menuItem) && hasRouterLink(menuItem)"
           [routerLink]="menuItem?.routerLink"
           routerLinkActive="active"
           [attr.disabled]="menuItem?.isDisabled">
            <mat-icon *ngIf="menuItem?.matIcon">{{ menuItem?.matIcon }}</mat-icon>
            <span *ngIf="menuItem?.i18nKey">{{ menuItem?.i18nKey | translate }}</span>
            <span *ngIf="!menuItem?.i18nKey">{{ menuItem?.text }}</span>
        </a>
        <a mat-button
           *ngIf="!hasChildMenu(menuItem) && !hasRouterLink(menuItem)"
           [href]="menuItem?.link"
           [attr.disabled]="menuItem?.isDisabled">
            <mat-icon *ngIf="menuItem?.matIcon">{{ menuItem?.matIcon }}</mat-icon>
            <span *ngIf="menuItem?.i18nKey">{{ menuItem?.i18nKey | translate }}</span>
            <span *ngIf="!menuItem?.i18nKey">{{ menuItem?.text }}</span>
        </a>
        <a mat-button
           *ngIf="hasChildMenu(menuItem)"
           [attr.disabled]="menuItem?.isDisabled">
            <mat-icon *ngIf="menuItem?.matIcon">{{ menuItem?.matIcon }}</mat-icon>
            <span *ngIf="menuItem?.i18nKey">{{ menuItem?.i18nKey | translate }}</span>
            <span *ngIf="!menuItem?.i18nKey">{{ menuItem?.text }}</span>
        </a>

        <ul class="sub-menu-items" *ngIf="hasChildMenu(menuItem)">
            <ng-container *ngFor="let item of menuItem?.children"
                          [ngTemplateOutlet]="listMenu"
                          [ngTemplateOutletContext]="{item: item}"></ng-container>
        </ul>
    </li>
</ng-template>

